import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './theme.css';
import Dashboard from './Dashboard';

try {
  if (localStorage.getItem('dp-theme') === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  }
} catch {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/"
    >
      <Dashboard />
    </ClerkProvider>
  </React.StrictMode>
);
